import { render, staticRenderFns } from "./TurnstileWidget.vue?vue&type=template&id=61736686&"
import script from "./TurnstileWidget.vue?vue&type=script&lang=ts&"
export * from "./TurnstileWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports